import { render, staticRenderFns } from "./RelatedColors.vue?vue&type=template&id=0c114711&scoped=true&"
import script from "./RelatedColors.vue?vue&type=script&lang=js&"
export * from "./RelatedColors.vue?vue&type=script&lang=js&"
import style0 from "./RelatedColors.vue?vue&type=style&index=0&id=0c114711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c114711",
  null
  
)

export default component.exports